// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wrapper_wrapper__1Eclv","topWrapper":"Wrapper_topWrapper__36mu4","title":"Wrapper_title__2y3kE","wrapperContent":"Wrapper_wrapperContent__1hP6V"};